import { Container, Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Whatsapp from "../assets/images/icons/whatsapp.png";
import Telegram from "../assets/images/icons/telegram.png";
import Facebook from "../assets/images/icons/facebook.png";
import Instagram from "../assets/images/icons/instagram.png";

import RNG from "../assets/images/providers/RNGCertified.webp";
import Gambling from "../assets/images/providers/GamblingCommission.webp";
import ResponsibleG from "../assets/images/providers/ResponsibleGamingFounding.webp";
import Gamble18 from "../assets/images/providers/18+gambleresponsibly.webp";
import Betfair from "../assets/images/providers/betfair.webp";

import UPIImg from "../assets/images/providers/upi.svg";
import VisaMasterCardImg from "../assets/images/providers/visa-master.svg";
import VisaMasterCardImg2 from "../assets/images/providers/visa-master2.svg";
import PaytmImg from "../assets/images/providers/paytm.svg";
import NetBankingImg from "../assets/images/providers/net-banking.svg";

import BitcoinImg from "../assets/images/providers/crypto/Bitcoin.webp";
import EthereumImg from "../assets/images/providers/crypto/Ethereum.webp";
import TetherImg from "../assets/images/providers/crypto/Tether.webp";
import DaiCoinImg from "../assets/images/providers/crypto/DaiCoin.webp";
import DogecoinImg from "../assets/images/providers/crypto/Dogecoin.webp";
import LitecoinImg from "../assets/images/providers/crypto/Litecoin.webp";
import { FaSpinner } from "react-icons/fa";

import HomeIconHover from "../assets/images/icons/footer/home-address.png";
import ExchangeHover from "../assets/images/icons/footer/throw.png";
import SlotsIcon from "../assets/images/icons/footer/android.png";
import EzugiIconHover from "../assets/images/icons/footer/casino-chip.png";
import CashierIconHover from "../assets/images/icons/footer/information.png";

const BeforeLoginFooter = () => {
  const navigate = useNavigate();
  const { appDetails } = useSelector((state) => state.app);

  return (
    <footer className="footer">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={4} className="text-center">
            <div className="foot-logo">
              <a href="/">
                {appDetails?.LOGO_URL ? (
                  <img src={appDetails?.LOGO_URL} alt="Logo" />
                ) : (
                  <FaSpinner />
                )}
              </a>
            </div>
            <div className="about-site">
              <p>{appDetails?.FOOTER_TEXT || ""}</p>
            </div>
            <div className="social-icons">
              <ul>
                <li>
                  <a
                    className="panel"
                    href={
                      appDetails?.WHATS_APP_URL != ""
                        ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                        : "javascript:void(0)"
                    }
                    target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                  >
                    <img src={Whatsapp} alt="Whatsapp Icon" />
                  </a>
                </li>
                <li>
                  <a
                    className="panel"
                    href={
                      appDetails?.TELEGRAM != ""
                        ? appDetails?.TELEGRAM
                        : "javascript:void(0)"
                    }
                    target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                  >
                    <img src={Telegram} alt="Telegram Icon" />
                  </a>
                </li>
                <li>
                  <a
                    className="panel"
                    href={
                      appDetails?.FACEBOOK != ""
                        ? appDetails?.FACEBOOK
                        : "javascript:void(0)"
                    }
                    target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                  >
                    <img src={Facebook} alt="Facebook Icon" />
                  </a>
                </li>
                <li>
                  <a
                    className="panel"
                    href={
                      appDetails?.INSTATGRAM != ""
                        ? appDetails?.INSTATGRAM
                        : "javascript:void(0)"
                    }
                    target={appDetails?.INSTATGRAM != "" ? "_blank" : ""}
                  >
                    <img src={Instagram} alt="Instagram Icon" />
                  </a>
                </li>
              </ul>
            </div>
          </Col>

          <Col xs={12} md={6} lg={4} className="quick-linksSection">
            <div className="quick-links">
              <h1>Quick Links</h1>
              <ul>
                <li>
                  <a href="/contactus">Contact Us</a>
                </li>
                <li>
                  <a href="/aboutus">About Us</a>
                </li>
                <li>
                  <a href="/privacypolicy ">Privacy Policy</a>
                </li>
                <li>
                  <a href="/responsiblegames">Responsible Gaming</a>
                </li>
                <li>
                  <a href="/fairplay">Fair Play</a>
                </li>
                <li>
                  <a href="/gamesrule">Games Rules</a>
                </li>
                <li>
                  <a href="/winning-rules">Winning Rules</a>
                </li>
                <li>
                  <a href="/terms">Terms and Conditions</a>
                </li>
              </ul>
            </div>
          </Col>

          <Col xs={12} lg={4} className="d-flex d-md-block flex-wrap">
            <div className="payment-methods">
              <h1>Payment Methods</h1>
              <ul>
                <li>
                  <img src={UPIImg} alt="upi" />
                </li>
                <li className="visa-mstr">
                  <img
                    src={VisaMasterCardImg}
                    alt="visa/master casrd"
                    className="d-none d-md-block"
                  />
                  <img
                    src={VisaMasterCardImg2}
                    alt="visa/master casrd"
                    className="d-md-none"
                  />
                </li>
                <li>
                  <img src={PaytmImg} alt="paytm" />
                </li>
                <li>
                  <img src={NetBankingImg} alt="net banking" />
                </li>
              </ul>
              <ul className="crypto-icons">
                <li>
                  <img src={BitcoinImg} alt="bitcoin" />
                </li>
                <li>
                  <img src={EthereumImg} alt="ethereum" />
                </li>
                <li>
                  <img src={TetherImg} alt="tether" />
                </li>
                <li>
                  <img src={DaiCoinImg} alt="daiCoin" />
                </li>
                <li>
                  <img src={DogecoinImg} alt="dogecoin" />
                </li>
                <li>
                  <img src={LitecoinImg} alt="litecoin" />
                </li>
              </ul>
              {/* <p style={{ color: "#848484" }}>
                  Accept, process &amp; disburse digital payments for your
                  business.
                </p> */}
            </div>
            <div className="responsible-gaming">
              <h1>Responsible Gaming</h1>
              <ul>
                <li>
                  <img
                    src={RNG}
                    alt="RNG Certified"
                    style={{ maxWidth: "90px" }}
                    height={44}
                  />
                </li>
                <li>
                  <img
                    src={Gambling}
                    alt="Gambling Commission"
                    style={{ maxWidth: "80px" }}
                    height={22}
                  />
                </li>
                <li>
                  <img
                    src={ResponsibleG}
                    alt="Responsible Gaming"
                    style={{ maxWidth: "120px" }}
                    height={35}
                  />
                </li>
                <li>
                  <img
                    src={Gamble18}
                    loading="lazy"
                    alt="Gamble Responsible"
                    style={{ maxWidth: "120px" }}
                    height={32}
                  />
                </li>
              </ul>
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs="12" className="text-center">
            <p className="mt-4 mb-0">
              &copy; 2025 Funn777.com. All rights reserved.
            </p>
          </Col>
        </Row>

        <div className="helpline d-none">
          <a
            className="panel"
            href={
              appDetails?.WHATS_APP_URL != ""
                ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                : "javascript:void(0)"
            }
            target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
          >
            <img src={Whatsapp} /> Whatsapp <p>{appDetails?.WHATS_APP_URL}</p>
          </a>
          <div className="facebook-footer">
            <a
              className="panel"
              href={
                appDetails?.TELEGRAM != ""
                  ? appDetails?.TELEGRAM
                  : "javascript:void(0)"
              }
              target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
            >
              <img src={Telegram} alt="telegram" />
            </a>
            <a
              className="panel social-icon watsapp"
              href={
                appDetails?.FACEBOOK != ""
                  ? appDetails?.FACEBOOK
                  : "javascript:void(0)"
              }
              target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
            >
              <img src={Facebook} />
            </a>
          </div>
          {/* <a href="tel:{user?.mobileno}">{user?.mobileno}</a> */}
        </div>

        <div className="d-flex justify-content-center mt-2 d-none">
          <p style={{ color: "rgb(204, 204, 204)" }}>
            Accept, process &amp; disburse digital payments for your business.
          </p>
        </div>

        <div className="d-flex justify-content-center mt-3 mb-3 d-none">
          <img
            src={Betfair}
            loading="lazy"
            className="mb-3 betfair"
            alt="Betfair Logo"
          />
        </div>

        <div className="footer-menu position-fixed start-0 bottom-0 z-index-2 d-lg-none d-block">
          <ul className="d-flex justify-content-evenly m-0 p-0 list-unstyled">
            <li>
              <a
                href="https://dl.dropbox.com/scl/fi/m4294wjrmho5nfujc70ij/Funn777.apk?rlkey=w4nxkgxfn2w9xa2z429wjoeof&st=k8ffyt6l&dl=0"
                download="https://dl.dropbox.com/scl/fi/m4294wjrmho5nfujc70ij/Funn777.apk?rlkey=w4nxkgxfn2w9xa2z429wjoeof&st=k8ffyt6l&dl=0"
              >
                {/* <SportsIcon /> */}
                <img src={SlotsIcon} className="hover" />
                <span>App</span>
              </a>
            </li>
            <li>
              <a
                href=""
                onClick={() => {
                  navigate("/sports/Inplay");
                }}
              >
                {/* <SportsIcon /> */}
                <img src={ExchangeHover} className="hover" />

                <span>Exchange</span>
              </a>
            </li>
            {/* <li>
              <a
                href=""
                onClick={() => {
                  navigate("/sign-in");
                }}
              >
                <img src={Exchange} alt="Exchange Icon" />
                <span>Exchange</span>
              </a>
            </li> */}

            <li>
              <a className="active HomeFooter" href="/">
                {/* <HomeIcon /> */}
                <div className="HomeImg">
                  <img src={HomeIconHover} className="hover" />
                </div>
                <span>Home</span>
              </a>
            </li>
            <li>
              <a
                href=""
                onClick={() => {
                  navigate("/casino/list");
                }}
              >
                {/* <GamesIcon /> */}
                <img src={EzugiIconHover} className="hover" />

                <span>Casino</span>
              </a>
            </li>
            <li>
              <a
                href={
                  appDetails?.WHATS_APP_URL != ""
                    ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                    : "javascript:void(0)"
                }
                target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
              >
                {/* <CashierIcon /> */}
                <img src={CashierIconHover} className="hover" />

                <span>Support</span>
              </a>
            </li>
          </ul>
        </div>
      </Container>
    </footer>
  );
};

export default BeforeLoginFooter;
